// time format for vue filter `| formatDate`
export default {
  zone: "America/New_York",
  format: "LL"
};
